/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const APPLICATION_STATUS_ACCUSATION = 10;
const APPLICATION_STATUS_AUTHORITY_NOTIFICATION = 12;
const APPLICATION_STATUS_ACCUSATION_OTHER = 15;
const APPLICATION_STATUS_LOCALITY = 20;
const APPLICATION_STATUS_SPEEDING = 25;
const APPLICATION_STATUS_ROAD_USERS_ENDANGERED = 30;
const APPLICATION_STATUS_DAMAGE = 33;
const APPLICATION_STATUS_RED_LIGHT = 36;
const APPLICATION_STATUS_SPEED = 40;
const APPLICATION_STATUS_DISTANCE = 45;
const APPLICATION_STATUS_VEHICLE = 50;
const APPLICATION_STATUS_DRIVERS_LICENSE_PERIOD = 100;
const APPLICATION_STATUS_FLENSBURG_POINTS = 110;
const APPLICATION_STATUS_FLASHED = 120;
const APPLICATION_STATUS_DRIVERS_LICENSE_INDISPENSABLE = 130;
const APPLICATION_STATUS_LEGAL_INSURANCE = 150;
const APPLICATION_STATUS_PERSONAL_DATA = 160;
const APPLICATION_STATUS_DOCUMENT_CHOICE = 178;
const APPLICATION_STATUS_DOCUMENTS = 180;
const APPLICATION_STATUS_SUMMARY = 185;
const APPLICATION_STATUS_POWER_OF_ATTORNEY = 190;
const APPLICATION_STATUS_DONE = 200;

export {
  APPLICATION_STATUS_ACCUSATION,
  APPLICATION_STATUS_ACCUSATION_OTHER,
  APPLICATION_STATUS_LOCALITY,
  APPLICATION_STATUS_SPEEDING,
  APPLICATION_STATUS_ROAD_USERS_ENDANGERED,
  APPLICATION_STATUS_DAMAGE,
  APPLICATION_STATUS_RED_LIGHT,
  APPLICATION_STATUS_SPEED,
  APPLICATION_STATUS_DISTANCE,
  APPLICATION_STATUS_VEHICLE,
  APPLICATION_STATUS_DRIVERS_LICENSE_PERIOD,
  APPLICATION_STATUS_FLENSBURG_POINTS,
  APPLICATION_STATUS_FLASHED,
  APPLICATION_STATUS_DRIVERS_LICENSE_INDISPENSABLE,
  APPLICATION_STATUS_AUTHORITY_NOTIFICATION,
  APPLICATION_STATUS_LEGAL_INSURANCE,
  APPLICATION_STATUS_PERSONAL_DATA,
  APPLICATION_STATUS_SUMMARY,
  APPLICATION_STATUS_POWER_OF_ATTORNEY,
  APPLICATION_STATUS_DOCUMENT_CHOICE,
  APPLICATION_STATUS_DOCUMENTS,
  APPLICATION_STATUS_DONE,
};
